import React, { useEffect, useState } from 'react';
import { Eye, LogOut } from 'lucide-react';
import { PREVIEW_EVENT, clearPreview, getPreview, rawPreview } from '../utils/founderPreview';
import { useLanguage } from '../contexts/LanguageContext';

const API = process.env.REACT_APP_BACKEND_URL;

let exiting = false;
export const exitFounderPreview = async () => {
  if (exiting) return;
  exiting = true;
  const raw = rawPreview();
  // Always tell the server (also after expiry, so the session is recorded as ended/expired).
  if (raw) {
    try { await fetch(`${API}/api/admin/founder-preview/end`, { method: 'POST', headers: { Authorization: `Bearer ${localStorage.getItem('shs_token')}`, 'X-SHS-Preview': raw.token } }); } catch { /* recorded by the server sweep */ }
  }
  clearPreview();
  window.location.assign('/admin/founder-preview');
};

export const FounderPreviewBanner = () => {
  const { language } = useLanguage();
  const es = language === 'es';
  const [, setTick] = useState(0);
  useEffect(() => {
    const on = () => setTick((n) => n + 1);
    window.addEventListener(PREVIEW_EVENT, on);
    const t = setInterval(on, 1000);
    return () => { window.removeEventListener(PREVIEW_EVENT, on); clearInterval(t); };
  }, []);
  const now = Date.now();
  const raw = rawPreview();
  const p = getPreview();
  useEffect(() => {
    if (raw && !p) exitFounderPreview();
    document.body.classList.toggle('founder-preview-active', Boolean(p));
  });
  if (!p) return null;
  const left = Math.max(0, Math.floor((new Date(p.expires_at).getTime() - now) / 1000));
  const mm = String(Math.floor(left / 60)).padStart(2, '0');
  const ss = String(left % 60).padStart(2, '0');
  return (
    <div className="fixed top-0 inset-x-0 z-[70] h-9 bg-amber-500 text-slate-950 shadow" data-testid="founder-preview-banner" role="status">
      <div className="max-w-7xl mx-auto h-full px-3 flex items-center gap-2 sm:gap-3 text-xs sm:text-sm whitespace-nowrap overflow-hidden">
        <Eye className="h-4 w-4 shrink-0" />
        <span className="font-semibold truncate" data-testid="founder-preview-banner-label">
          {es ? 'Vista previa del Fundador' : 'Founder Preview'}: {es ? p.label.es : p.label.en} ({es ? 'simulado' : 'simulated'})
        </span>
        <span className="hidden md:inline">· {es ? 'nada se guarda · historial de aprendizaje de muestra · consola de administración bloqueada' : 'nothing is saved · sample learning history · Admin Console blocked'}</span>
        <span className="font-mono" data-testid="founder-preview-countdown">{mm}:{ss}</span>
        <button type="button" onClick={exitFounderPreview} data-testid="founder-preview-exit-btn"
          className="ml-auto shrink-0 inline-flex items-center gap-1 rounded-full bg-slate-950 text-white px-3 py-1 text-xs font-semibold hover:bg-slate-800 transition-colors">
          <LogOut className="h-3.5 w-3.5" />{es ? <><span className="sm:hidden">Salir</span><span className="hidden sm:inline">Salir de la vista previa</span></> : 'Exit Preview'}
        </button>
      </div>
    </div>
  );
};
